import * as React from "react"
import { Gauge } from "lucide-react"

import { useMotionPreference } from "../utils/motion-preference"

const MOTION_OPTIONS = [
  { value: "auto", label: "Auto" },
  { value: "reduced", label: "Reduced" },
  { value: "full", label: "Full" },
]

const MotionPreferenceControl = () => {
  const { mode, effectiveMotion, setMode } = useMotionPreference()
  const [isExpanded, setIsExpanded] = React.useState(false)
  const controlRef = React.useRef(null)
  const segmentsId = "motion-preference-options"

  React.useEffect(() => {
    const handlePointerDown = event => {
      if (!controlRef.current || controlRef.current.contains(event.target)) {
        return
      }

      setIsExpanded(false)
    }

    window.addEventListener("pointerdown", handlePointerDown)
    return () => window.removeEventListener("pointerdown", handlePointerDown)
  }, [])

  const handleOptionClick = value => {
    setMode(value)
    setIsExpanded(false)
  }

  return (
    <section
      ref={controlRef}
      className={`motion-control${isExpanded ? " is-expanded" : ""}`}
      aria-label="Motion preference"
      data-glass-exclude
      onKeyDown={event => {
        if (event.key === "Escape") {
          setIsExpanded(false)
        }
      }}
    >
      <button
        type="button"
        className="motion-control__label"
        aria-expanded={isExpanded}
        aria-controls={segmentsId}
        aria-label={isExpanded ? "Hide motion options" : "Show motion options"}
        onClick={() => setIsExpanded(current => !current)}
      >
        <Gauge size={14} aria-hidden="true" />
        <span>Motion</span>
      </button>
      <div
        id={segmentsId}
        className="motion-control__segments"
        role="group"
        aria-label="Motion preference"
      >
        {MOTION_OPTIONS.map(option => (
          <button
            key={option.value}
            type="button"
            className={mode === option.value ? "is-active" : ""}
            aria-pressed={mode === option.value}
            title={`${option.label} motion`}
            onClick={() => handleOptionClick(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
      <span className="motion-control__status">
        {effectiveMotion === "reduced" ? "Reduced active" : "Full active"}
      </span>
    </section>
  )
}

export default MotionPreferenceControl
